module.exports = __webpack_public_path__ + "static/media/keno_new.9a7a9565.mp3";